import React, { useCallback, useState, useEffect } from "react";

type LabeledInputProps = {
  label: string;
  value: string | number;
  required?: boolean;
  onChange: (v: string) => void;
  type?: string;
  mask?: (input: string) => string;
  showValidation?: boolean;
  className?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  inputMode?: any;
  enable?: boolean;
};

export default function LabeledInput({
  label,
  value,
  required,
  onChange,
  type = "text",
  mask,
  inputMode,
  className,
  showValidation = false,
  enable = false
}: LabeledInputProps) {
  const [inputValue, setInputValue] = useState(value);
  const [touched, setTouched] = useState(false);

  showValidation = required ? true : false;

  const isEmpty = !inputValue || String(inputValue).trim() === '';
  const showError = required && isEmpty && (touched || showValidation);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      let val = e.target.value;
      if (mask) {
        val = mask(val);
      }
      setInputValue(val);
      onChange(val);
    },
    [mask, onChange]
  );

  const handleBlur = () => {
    setTouched(true);
  };


  useEffect(() => {
    setInputValue(value);
  }, [value]);

  return (
    <label className="flex flex-col gap-2">
      <span className="text-sm ">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </span>

      <input
        type={type}
        disabled={enable}
        value={inputValue}
        onChange={handleChange}
        onBlur={handleBlur}
        inputMode={inputMode}
        required={required}
        aria-required={required}
        className={
          className
            ? className
            : `rounded border px-4 py-3 focus:outline-none focus:ring-2 transition-colors ${showError
              ? 'focus:ring-red-200 focus:border-red-400'
              : 'border-neutral-300 focus:ring-neutral-800'
            }`
        }
      />
    </label>
  );
}